import { InternalErrorEnum } from '../enums';

export class InternalError extends Error {
    /**
     * Validates that the data is not null or undefined
     * @param data
     */
    static validatesIsDefined(data): void {
        if (data === null || data === undefined) {
            throw new InternalError(InternalErrorEnum.nonNullExpected, 'Non null or undefined value was expected');
        }
    }

    constructor(public status: number, public description: string) {
        super();
    }
}
